export default __webpack_public_path__ + "static/media/SEC1530.34I-37172_-21987_0.c781d01e.jpg";